(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deal48-home"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{const box=root.querySelector('[data-deal48-countdown]');if(!box)return;const tick=()=>{const now=new Date(),end=new Date(now);end.setHours(23,59,59,999);const left=Math.max(0,end-now),hours=Math.floor(left/36e5),minutes=Math.floor(left%36e5/6e4),seconds=Math.floor(left%6e4/1e3);box.querySelector('[data-hours]').textContent=String(hours).padStart(2,'0');box.querySelector('[data-minutes]').textContent=String(minutes).padStart(2,'0');box.querySelector('[data-seconds]').textContent=String(seconds).padStart(2,'0')};tick();setInterval(tick,1000)};document.querySelectorAll('.d48').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.d48').forEach(init))})();

  } catch(e) { console.error(e); }
})();
})();
